import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class TrustPilotCypressAttribute extends CypressAttribute {
  static buttons = {};

  static inputs = {};

  static views = {
    RATING_IMAGE: 'TrustPilotCypressAttribute:views:RATING_IMAGE',
    REVIEW_WIDGET: 'TrustPilotCypressAttribute:views:REVIEW_WIDGET'
  };
}
